import { render, staticRenderFns } from "./EditPolicy.vue?vue&type=template&id=c1335550"
import script from "./EditPolicy.vue?vue&type=script&lang=js"
export * from "./EditPolicy.vue?vue&type=script&lang=js"
import style0 from "./EditPolicy.vue?vue&type=style&index=0&id=c1335550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports